import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { Message } from '../../interfaces/message';
import { DataService } from '../../services/data.service';
import { environment } from 'src/environments/environment';

declare var window: any;

@Component({
  selector: 'app-widget-messages',
  templateUrl: './widget-messages.component.html',
  styleUrls: ['./widget-messages.component.scss']
})
export class WidgetMessagesComponent implements OnInit {
  @Input({ required: true }) widgetData!: any;
  @Output() widgetLoaded: EventEmitter<any> = new EventEmitter<any>();

  messages: Message[] = [];
  @HostBinding('style.--messages-height') height!: string;
  loading: boolean = false;
  isServerError: boolean = false;

  constructor(private dataService: DataService) { }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.loading = true;
    let url = environment.apiUrl + '/Portal/Api/Widgets/GetMessagesForWidget';
    let request: any = {
      cultureCode: this.dataService.getCultureCode(),
      maxDisplayItems: this.widgetData.maxDisplayItems,
      pinnedMessages: this.widgetData.pinnedMessages
    };
    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {
        this.messages = responseData;
        this.height = this.messages.length ? '288px' : 'auto';
        this.widgetLoaded.emit({ exists: true, count: this.messages.length, title: this.widgetData.title, loading: false });
        this.loading = false;
      },
      error: (e: any) => {
        console.error(e);
        this.loading = false;
        this.isServerError = true;
      }
    });
  }

  getMessageUrl(nodeId: string): string {
    return this.widgetData.allLinkUrl + '?id=' + nodeId;
  }

  openPopup(nodeId: any, event: MouseEvent) {
    event.preventDefault();
    window.MessagePopup.openMessagePopup(nodeId, event.currentTarget!);
  }
}
